"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");
































































































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      pickerOptions: { disabledDate: function disabledDate(time) {return time.getTime() > Date.now();} }, searchData: { name: '', isEnabled: '', time: '', parentCode: '', parentCodeOld: '' }, newadd: false, title: '新增', addData: { id: '', isEnabled: '', name: '', code: '', parentCode: '' }, defaultData: { id: '', isEnabled: '', name: '', code: '', parentCode: '' }, rules: { name: [{ required: true, message: '请输入省份名称', trigger: 'blur' }], code: [{ required: true, message: '请输入省份编码', trigger: 'blur' }], isEnabled: [{ required: true, message: '请选择是否启用', trigger: 'blur' }] } };}, filters: { isEnabledFilter: function isEnabledFilter(val) {if (val == '0') {return '禁用';} else if (val == '1') {return '启用';} else {return val;}} }, mounted: function mounted() {var self = this;self.searchData.parentCode = self.$route.query.code;self.searchData.parentCodeOld = self.$route.query.parentCode;self.init();}, methods: { checkPermission: _user.checkPermission, init: function init() {var self = this;var params = Object.assign({}, self.searchData);if (params.time) {params.startTime = params.time[0] + ' 00:00:00';params.endTime = params.time[1] + ' 23:59:59';}delete params['time'];self.getData('/api/faRegion/parentCode/' + self.$route.query.code, params, function (res) {self.tableData = res;});}, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.isEnabled = '';this.searchData.time = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faRegion/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.newimg = '';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faRegion', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },

    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      self.getData('/api/faRegion/' + item.id, null, function (res) {
        self.addData = {
          id: res.id,
          code: res.code,
          name: res.name,
          parentCode: res.parentCode,
          isEnabled: res.isEnabled };

        self.newadd = true;
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faRegion/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    //启用/禁用
    updateEnabled: function updateEnabled(row) {
      var self = this;
      console.log(row);
      var isEnabled = '';
      if (row.isEnabled == '0') {
        isEnabled = '1';
      } else if (row.isEnabled == '1') {
        isEnabled = '0';
      }
      self.postData('/api/faRegion/' + row.id + '/enable/' + isEnabled, null, function (res) {
        self.$message({
          message: '修改成功!',
          type: 'success' });

        self.init();
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    } } };exports.default = _default;